import { usePermissionStore } from '@/lib/store/permission-store';

/**
 * Hook to access user permissions and roles from the Zustand store.
 */
export const usePermissions = () => {
  const { 
    permissions, 
    roles, 
    isReady, 
    setPermissionsAndRoles, 
    hasPermission, 
    hasRole,
    hasRoles
  } = usePermissionStore();

  const isAdmin = hasRole('admin');
  const isVip = hasRole('vip_user');

  return { 
    permissions,
    roles,
    isReady,
    setPermissionsAndRoles,
    hasPermission, 
    hasRole,
    hasRoles,
    isAdmin,
    isVip,
    isVipOrAdmin: isAdmin || isVip,
  };
};